var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('PageHeader',{attrs:{"title":_vm.__('company.views.task-types.create.title'),"go-back-action":_vm.goBack}}),_c('v-card',{staticClass:"pa-4 mt-8"},[_c('Form',{attrs:{"form":_vm.form}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }